import React from "react";
import "./Sustainabillity.css";

const Sustainabillity = () => {
  return (
    <div className="sustainabillity_parent_div">
      <h1>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dicta
        perferendis corrupti numquam accusamus officia architecto corporis.
        Fugiat, error? Illo fugiat voluptatibus fugit placeat eligendi
        consequatur itaque maxime eveniet dicta ex?
      </h1>
    </div>
  );
};

export default Sustainabillity;
